import { z } from 'zod'

const parentCategorySchema = z.object({
  name: z.string(),
  allow_sub: z.boolean(),
  children: z.array(z.string()).optional(),
})

export const transactionCategorySchema = z.object({
  transaction_type: z.string(),
  categories: z.array(parentCategorySchema),
})

export const fetchTransactionCategoriesResultSchema = z.object({
  result: z.array(transactionCategorySchema),
})

export const categoryFilterSchema = z.array(z.string())
